module.exports = __webpack_public_path__ + "assets/img/img220.35b706e1.png";